import { useState } from "react";
import { TrendingUp } from "lucide-react";
import { money, num } from "./meta";

function Dropped({ u }) {
  const [open, setOpen] = useState(false);
  if (!u.dropped_count) return null;
  return (
    <>
      <button type="button" onClick={() => setOpen(!open)} data-testid="uc-dropped-toggle"
              className="rounded-full border border-amber-300 bg-white px-3 py-1 font-semibold transition-colors hover:border-amber-500">
        {num(u.dropped_count)} charged last cycle, no calls now</button>
      {open && (
        <div className="basis-full rounded-md border border-amber-200 bg-white p-2" data-testid="uc-dropped-list">
          <div className="grid max-h-48 grid-cols-2 gap-x-6 overflow-auto font-mono text-[11px] sm:grid-cols-3 lg:grid-cols-4">
            {u.dropped.map((d) => <span key={d.domain} className="flex justify-between gap-2"><span className="truncate">{d.domain}</span><span className="tabular-nums text-slate-500">{money(d.prev_amount)}</span></span>)}
          </div>
          {u.dropped_count > u.dropped.length && <p className="mt-1 text-[11px] text-slate-500">Showing the biggest {u.dropped.length} of {num(u.dropped_count)}.</p>}
        </div>)}
    </>
  );
}

const REVIEW_OPTS = [["", "All flagged"], ["open", "Not reviewed"], ["done", "Reviewed"]];

/** "Compared with last cycle" bar: the jump filter, the review filter and the stopped domains. */
export function CompareBar({ run, f, set, reviewed }) {
  const pv = run.cycle?.previous;
  if (!pv) return null;
  const u = run.usage;
  const rule = u.jump_rule || {};
  return (
    <div className="flex flex-wrap items-center gap-3 rounded-lg border border-amber-200 bg-amber-50/60 px-4 py-2.5 text-xs text-amber-900" data-testid="uc-compare">
      <TrendingUp className="h-4 w-4 shrink-0" />
      <span>Compared with the <b>{pv.label}</b> cycle's full total <b className="font-mono">{money(pv.total)}</b> — flagged when a domain moves {rule.pct}% or more (domains under {money(rule.min)} ignored).
        {pv.empty_days?.length > 0 && <span className="text-rose-700"> {pv.empty_days.length} day(s) of that cycle have no calls saved, so its totals are low.</span>}</span>
      <button type="button" onClick={() => set("jump", !f.jump)} data-testid="uc-jump-toggle"
              className={`ml-auto rounded-full border px-3 py-1 font-semibold transition-colors ${f.jump ? "border-amber-700 bg-amber-700 text-white" : "border-amber-300 bg-white hover:border-amber-500"}`}>
        {num(u.jumps)} unusual change{u.jumps === 1 ? "" : "s"}{f.jump ? " · showing" : ""}</button>
      {u.jumps > 0 && <span className="font-medium" data-testid="uc-reviewed-count">{num(reviewed)} reviewed · {num(Math.max(u.jumps - reviewed, 0))} to go</span>}
      {f.jump && (
        <select value={f.review} onChange={(e) => set("review", e.target.value)} className="h-7 rounded-md border border-amber-300 bg-white px-2 text-xs" data-testid="uc-review-filter">
          {REVIEW_OPTS.map(([v, l]) => <option key={v} value={v}>{l}</option>)}</select>)}
      <Dropped u={u} />
    </div>
  );
}
